import { createContext } from "react";
export const Todocontext=createContext([]);